import { render, staticRenderFns } from "./MigrationNoticeDialog.vue?vue&type=template&id=48f89a3d&scoped=true&"
import script from "./MigrationNoticeDialog.vue?vue&type=script&lang=js&"
export * from "./MigrationNoticeDialog.vue?vue&type=script&lang=js&"
import style0 from "./MigrationNoticeDialog.vue?vue&type=style&index=0&id=48f89a3d&scoped=true&lang=css&"
import style1 from "./MigrationNoticeDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f89a3d",
  null
  
)

export default component.exports